import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import {setUser} from '@sentry/react';
import {selectUserShortInfo} from 'src/modules/main/services/user-info-slice';

export const useSentry = () => {
    const user = useSelector(selectUserShortInfo);

    useEffect(() => {
        setUser({
            id: String(user?.userId),
        });
    }, [user?.userId]);

};
